module.exports = __webpack_public_path__ + "static/media/error-flat.5084cee2.svg";